/*
 * VAINSTAL motion system.
 * Restrained scroll reveals + button/link micro-interactions.
 * Fully disabled under prefers-reduced-motion.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function autoTagHomepageSections() {
    if (window.location.pathname !== '/') return;

    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
      var wrapper = section.querySelector('.layout-panel-flex');
      if (!wrapper) return;

      Array.prototype.forEach.call(wrapper.children, function (el, i) {
        el.style.setProperty('--reveal-i', i);
        el.setAttribute('data-reveal', '');
      });
    });
  }

  function initScrollReveal() {
    var elements = document.querySelectorAll('[data-reveal]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initConcernIndex() {
    document.querySelectorAll('[data-concern-preview]').forEach(function (preview) {
      var container = preview.closest('.concern-index');
      if (!container) return;

      var rows = container.querySelectorAll('[data-concern-row]');
      var imageEl = preview.querySelector('[data-concern-preview-image]');
      var labelEl = preview.querySelector('[data-concern-preview-label]');
      var titleEl = preview.querySelector('[data-concern-preview-title]');
      var linkEl = preview.querySelector('[data-concern-preview-link]');
      if (!rows.length || !imageEl) return;

      function activate(row) {
        rows.forEach(function (r) {
          r.classList.remove('is-active');
        });
        row.classList.add('is-active');
        imageEl.style.backgroundImage = 'url(' + row.getAttribute('data-product-image') + ')';
        labelEl.textContent = row.getAttribute('data-concern-label') + ' · STARTS WITH';
        titleEl.textContent = row.getAttribute('data-product-title');
        linkEl.href = row.getAttribute('data-product-url') || row.getAttribute('href');
      }

      rows.forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          activate(row);
        });
        row.addEventListener('focus', function () {
          activate(row);
        });
      });

      var initial = container.querySelector('[data-concern-row].is-active') || rows[1] || rows[0];
      if (initial) activate(initial);
    });
  }

  /*
   * Cart drawer auto-open fix (audit B1).
   *
   * Horizon's own cart-drawer.js decides whether to auto-open by reading
   * `.cart-drawer--empty` synchronously at the moment the add-to-cart event
   * fires — before the fetch to /cart/add.js has even been sent. On a
   * brand-new session that class is still present from the server-rendered
   * empty state, so the drawer stays closed on the shopper's very first
   * add-to-cart and only starts opening correctly from the second add
   * onward, once something is already in the cart. First-time visitors —
   * i.e. everyone converting for the first time — get no visual
   * confirmation at all that anything happened.
   *
   * This listens for the same event and opens the drawer itself once the
   * add has genuinely succeeded, instead of relying on that stale check.
   */
  function initCartDrawerAutoOpenFix() {
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.action !== 'add' || !event.promise) return;

      event.promise
        .then(function (result) {
          var detail = result && result.detail;
          if (detail && detail.didError) return;

          var drawer = document.getElementById('cart-drawer');
          if (!drawer || typeof drawer.open !== 'function' || drawer.hasAttribute('open')) return;

          var openModal = document.querySelector('dialog:modal');
          if (openModal) {
            openModal.addEventListener(
              'close',
              function () {
                if (!drawer.hasAttribute('open')) drawer.open();
              },
              { once: true }
            );
            return;
          }

          drawer.open();
        })
        .catch(function () {});
    });
  }

  if (!prefersReducedMotion) {
    autoTagHomepageSections();
    if ('IntersectionObserver' in window) {
      initScrollReveal();
    }
  }

  initConcernIndex();
  initCartDrawerAutoOpenFix();
})();
